import { CsbHelper } from '@recruiting-solutions/rs-shared';
import { Component, Host, Prop, State, h, Element } from '@stencil/core';
import { ArvIcons } from 'apps/arv-components/src/global/arv-icons';
@Component({
    tag: 'arv-language-popup',
    styleUrl: 'arv-language-popup.scss',
    shadow: true,
})
export class ArvLanguagePopup {
    @Element()
    element;

    @Prop()
    languages: { code: string; label: string; buttonText: string; hintText: string }[] = [
        { code: 'en_US', label: 'English', buttonText: 'Continue', hintText: 'The website is available in other languages. Do you want to change the language?' },
        { code: 'de_DE', label: 'Deutsch', buttonText: 'Weiter', hintText: 'Die Website ist in anderen Sprachen verfügbar. Möchten Sie die Sprache ändern?' },
        { code: 'nl_NL', label: 'Nederlands', buttonText: 'Doorgaan', hintText: 'De website is beschikbaar in andere talen. Wilt u de taal wijzigen?' },
        { code: 'pl_PL', label: 'Polski', buttonText: 'Kontynuuj', hintText: 'Strona jest dostępna w innych językach. Czy chcesz zmienić język?' },
        // { code: 'tr_TR', label: 'Türkçe', buttonText: 'Devam et', hintText: 'Web sitesi diğer dillerde mevcut. Dil değiştirmek istiyor musunuz?' },
        { code: 'es_ES', label: 'Español', buttonText: 'Continuar', hintText: 'El sitio web está disponible en otros idiomas. ¿Quiere cambiar el idioma?' },
        { code: 'it_IT', label: 'Italiano', buttonText: 'Continua', hintText: 'Il sito web è disponibile in altre lingue. Vuoi cambiare la lingua?' },
        // { code: 'pt_BR', label: 'Português', buttonText: 'Continuar', hintText: 'O site está disponível em outros idiomas. Você quer mudar o idioma?' },
        { code: 'fr_FR', label: 'Français', buttonText: 'Continuer', hintText: "Le site Web est disponible dans d'autres langues. Voulez-vous changer de langue?" },
    ];

    @State()
    selectedLocale: string = 'de_DE';

    @State()
    browserLanguage;

    @State()
    newLanguage: string;

    @State()
    label: string = 'Deutsch';

    @State()
    showPopup: boolean;

    @State()
    text: string;

    @State()
    buttonText: string;

    componentDidLoad() {
        this.browserLanguage = navigator.language.split('-')[0];
        this.selectedLocale = CsbHelper.getLocale();
        this.getNewLanguage();
        this.getTranslations(this.browserLanguage);
        this.getStateForPopup();
    }

    getNewLanguage() {
        for (const language of this.languages) {
            if (language.code.substring(0, 2) === navigator.language.split('-')[0]) {
                this.newLanguage = language.code;
                break;
            }
        }
    }

    disableLanguagePopup() {
        localStorage.setItem('disableLanguagePopup', 'true');
        this.getStateForPopup();
    }

    nav() {
        const params = new URLSearchParams(location.search);
        params.set('locale', this.newLanguage);
        params.set('path', this.newLanguage);
        const url = new URL(location.href);
        url.search = params.toString();
        location.href = url.toString();
        this.disableLanguagePopup();
    }

    languageChanged(code: string, label: string) {
        this.newLanguage = code;
        this.label = label;
        this.getTranslations(code);
    }

    getTranslations(code: string) {
        this.languages.map(lang => (lang.code.split('_')[0] === code ? ((this.text = lang.hintText), (this.buttonText = lang.buttonText), (this.label = lang.label)) : ''));
    }

    getStateForPopup() {
        if (this.isApplyPage() || this.isPostingPage() || this.isDCFPage()) {
            this.showPopup = false;
            this.disableScroll();
            return;
        }
        if (localStorage.getItem('disableLanguagePopup')) {
            this.showPopup = false;
        } else {
            this.showPopup = this.browserLanguage != this.selectedLocale.split('_')[0];
        }
        this.disableScroll();
    }

    disableScroll() {
        if (this.showPopup) {
            document.body.classList.add('stopScroll');
        } else {
            document.body.classList.remove('stopScroll');
        }
    }

    render() {
        if (this.isApplyPage() || this.isPostingPage() || this.isDCFPage()) {
            return <Host></Host>;
        }
        return (
            <Host>
                <main class={this.showPopup ? 'open' : 'hide'}>
                    <div class="background">
                        <div class="content">
                            <span class="text">{this.text}</span>

                            <div class="group">
                                <div class="world">{ArvIcons.getGeneric('world', 'black')}</div>
                                <div
                                    class="dropdown"
                                    onClick={() => this.toggleDropdown()}
                                    onKeyDown={event => {
                                        if (event.key === ' ') {
                                            this.toggleDropdown();
                                            event.preventDefault();
                                            event.stopPropagation();
                                        }
                                    }}
                                    tabIndex={0}
                                >
                                    <span>
                                        {this.label} {ArvIcons.getGeneric('chevron_down', 'black', 16, 'icon')}
                                    </span>

                                    <div class="inner">
                                        {this.languages.map(item => (
                                            <span tabIndex={0} onClick={() => this.languageChanged(item.code, item.label)}>
                                                {item.label}
                                            </span>
                                        ))}
                                    </div>
                                </div>

                                <arv-button-animated onClick={() => this.nav()} text={this.buttonText}></arv-button-animated>
                            </div>
                            <div
                                class="close"
                                tabIndex={0}
                                onClick={() => this.disableLanguagePopup()}
                                onKeyDown={event => {
                                    if (event.key === ' ') {
                                        this.disableLanguagePopup();
                                        event.stopPropagation();
                                        event.preventDefault();
                                    }
                                }}
                            >
                                {ArvIcons.getGeneric('close', 'black')}
                            </div>
                        </div>
                    </div>
                </main>
            </Host>
        );
    }

    toggleDropdown() {
        const el = this.element.shadowRoot.querySelector('.inner') as HTMLDivElement;
        const iconElement = this.element.shadowRoot.querySelector('.icon') as HTMLDivElement;
        el.classList.toggle('open');
        iconElement.classList.toggle('rotate');
    }
    isPostingPage() {
        return document?.body.classList.contains('arv-job-posting-page');
    }

    isApplyPage() {
        return document?.body.classList.contains('arv-apply-page');
    }

    isDCFPage() {
        return document?.body.classList.contains('landing-page');
    }
}
